import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <dx-popup
      [visible]="visible"
      [width]="400"
      [height]="'auto'"
      [showTitle]="true"
      [dragEnabled]="true"
      [closeOnOutsideClick]="true"
      [showCloseButton]="true"
      (onHiding)="onClose('No')">
      <div *dxTemplate="let data of 'title'">
        <div [innerHTML]="title"></div>
      </div>
      <div *dxTemplate="let data of 'content'">
        <p [innerHTML]="content"></p>
        <div style="text-align: right; margin-top: 15px;">
          <dx-button text="No" (onClick)="onClose('No')"></dx-button>
          <dx-button text="Yes" type="success" (onClick)="onClose('Yes')"></dx-button>
        </div>
      </div>
    </dx-popup>
  `,
})
export class ConfirmDialogComponent {
  @Input() visible = false;
  @Input() title = '';
  @Input() content = '';
  @Output() closed = new EventEmitter<string>();

  onClose(result: string) {
    this.visible = false;
    this.closed.emit(result);
  }
}
